import { render, staticRenderFns } from "./spechToTextarea.vue?vue&type=template&id=5abf7478&"
import script from "./spechToTextarea.vue?vue&type=script&lang=js&"
export * from "./spechToTextarea.vue?vue&type=script&lang=js&"
import style0 from "./spechToTextarea.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports